<svelte:options customElement={{ tag: 'vv-news', shadow: 'none' }} />

<script context="module">
    import appCssUrl from '../../app.css?inline';
    let style = '<style' + `>${appCssUrl}</style>`;
</script>

<script lang="ts">
    import Index from "./Index.svelte";
    import NewsletterPage from "./NewsletterPage.svelte";
    import BlogPage from "./BlogPage.svelte";
    
    import Router from 'svelte-spa-router'
    import { wrap } from 'svelte-spa-router/wrap'

    export const routes = {
        '/': Index,
        '/Newsletters/:id': wrap({
            component: NewsletterPage
        }),
        '/Blog/:id': wrap({
            component: BlogPage
        }),
        
    };</script>

{@html style}

<div>
    <div class="flex flex-col grid-cols-6 @xl:grid gap-4">
        <Router {routes}/>
    </div>
</div>